import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
  multiline?: boolean;
}
export function Input({
  label,
  error,
  helperText,
  multiline = false,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || props.name || Math.random().toString(36).substr(2, 9);
  const baseStyles = 'w-full px-4 py-2 rounded-lg border bg-white focus:outline-none focus:ring-2 focus:ring-primary-purple focus:border-transparent transition-all duration-200 disabled:bg-gray-100 disabled:text-gray-500';
  const borderStyles = error ? 'border-status-danger' : 'border-gray-300';
  return <div className={`w-full ${className}`} data-id="element-367">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-text-primary mb-1.5" data-id="element-368">
          {label}
        </label>}

      {multiline ? <textarea id={inputId} className={`${baseStyles} ${borderStyles} min-h-[100px] resize-y`} {...props as React.TextareaHTMLAttributes<HTMLTextAreaElement>} data-id="element-369" /> : <input id={inputId} className={`${baseStyles} ${borderStyles}`} {...props as React.InputHTMLAttributes<HTMLInputElement>} data-id="element-370" />}

      {error && <p className="mt-1 text-sm text-status-danger" data-id="element-371">{error}</p>}

      {helperText && !error && <p className="mt-1 text-sm text-text-secondary" data-id="element-372">{helperText}</p>}
    </div>;
}